import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupAxiosInterceptor } from './lib/axiosInterceptor';

// Setup axios interceptor for JWT token injection
setupAxiosInterceptor();

const rootId = process.env.NODE_ENV === 'development' ? 'root' : 'curatu-root';
const root = ReactDOM.createRoot(document.getElementById(rootId));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
